import React, { FC } from 'react';

import { Box, Button2, Stack, Typography, useDesktop, useMediaSwitch, useMobile } from 'Modules/ui3';
import { fileUrl } from 'Modules/ui';
import { useConfig } from 'Modules/core/config';

import InvestImage from './assets/Invest.png';
import InvestMobileImage from './assets/InvestMobile.png';
import InvestTabletImage from './assets/InvestTablet.png';
import { landingAnchorRoutes } from '../../routes/landingAnchorRoutes';
import { getIdFromAnchor } from '../../utils';


export const Invest: FC = () => {
    const isDesktop = useDesktop();
    const isMobile = useMobile();
    const showAuthorization = useConfig('showAuthorization');
    const lkflUrl = useConfig('lkflUrl');
    return (
        <Box
            id={getIdFromAnchor(landingAnchorRoutes.investors.route)}
            {...isDesktop ? {
                px: 4,
            } : {
                mt: -10,
            }}
        >
            <Box
                position='relative'
                height='100vh'
                overflow='hidden'
                bgcolor='#F6F6F6'
                {...isDesktop && {
                    borderRadius: 12,
                    minHeight: '980px',
                }}
            >
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster="data:image/svg+xml;utf8,<svg xmlns='http://w3.org' width='100% header' height='100%'><rect width='100%' height='100%' fill='%23F6F6F6'/></svg>"
                    style={{
                        position: 'absolute',
                        display: 'block',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 1,
                        objectFit: 'cover',
                        backgroundColor: 'transparent',
                    }}
                    ref={el => {
                        if (el) {
                            el.setAttribute('muted', '');
                            el.defaultMuted = true;
                            el.muted = true;
                        }
                    }}
                >
                    <source src='/Frontend/videos/invest.mp4' />
                </video>
                <Stack
                    position='relative'
                    height='100%'
                    px={isMobile ? 5 : 12}
                    pt={useMediaSwitch(37, 26, 22)}
                    pb={useMediaSwitch(22, 10, 8)}
                    alignItems='center'
                    justifyContent='space-between'
                    spacing={useMediaSwitch(0, 16, 12)}
                    borderRadius={12}
                    alignSelf='center'
                    bgcolor='#F4F3F2'
                >
                    <Stack spacing={isDesktop ? 12 : 8} alignItems='center'>
                        <Typography
                            fontFamily='Hauora'
                            color='#F4F3F2'
                            fontSize={useMediaSwitch('72px', '48px', '32px')}
                            fontWeight={700}
                            lineHeight={1.3}
                            zIndex={2}
                            sx={{
                                mixBlendMode: 'difference',
                            }}
                        >
                            Инвестируйте легко
                        </Typography>
                        {showAuthorization && (
                            <Button2
                                LinkComponent='a'
                                href={lkflUrl}
                                variantType='main'
                                variant='primary'
                                size='large'
                                sx={{
                                    bgcolor: '#242424',
                                    borderRadius: 5,
                                    fontFamily: 'Hauora',
                                    fontWeight: 700,
                                    lineHeight: '24px',
                                    zIndex: 2,
                                }}
                            >
                                Начать инвестировать
                            </Button2>
                        )}
                    </Stack>
                    <Box
                        width={isMobile ? '290px' : '396px'}
                        height={isMobile ? '400px' : '564px'}
                        flexShrink={0}
                        zIndex={2}
                        {...isDesktop && {
                            position: 'absolute',
                            bottom: 0,
                        }}
                        sx={{
                            background: `url(${fileUrl(useMediaSwitch(InvestImage, InvestTabletImage, InvestMobileImage))}) center / cover no-repeat`,
                        }}
                    />
                </Stack>
            </Box>
        </Box>
    );
};
